import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OperationType } from "../../../../../core/models/enums/core.enums";
import PrwcBasicButton from "../../../../../ui/widgets/custom/buttons/PrwcBasicButton";
import PrwcSidebar from "../../../../../ui/widgets/custom/PrwcSidebar";
import ShiftCategoryContainer from "../../containers/ShiftCategoryContainer";
import ShiftCategoryListContainer from "../../containers/ShiftCategoryListContainer";

const ShiftCategoryPage: React.FC<any> = () => {
  const { t } = useTranslation();
  const [isSideBarVisible, setIsSideBarVisible] = useState(false);
  // const userCategoriesFacade: any = useUserCategoriesFacade();
  const [operationType, setOperationType] = useState(OperationType.ADD);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const handleAddShiftCategory = () => {
    setOperationType(OperationType.ADD);
    setSelectedRowData(null);
    setIsSideBarVisible(true);
  };

  const handleEditShiftCategory = (rowData: any) => {
    setOperationType(OperationType.EDIT);
    setSelectedRowData(rowData);
    console.log("handle edit ---");
    console.log(rowData);
    setIsSideBarVisible(true);
  };

  return (
    <div>
      <div className="flex items-center justify-between px-2 border-gray-300">
        <div className="text-2xl font-semibold text-gray-700 ">
          {t("shiftCategory.label.shiftCategory")}
        </div>
        <div>
          <PrwcBasicButton
            labelKey={t("shiftCategory.action.addShiftCategory")}
            className="h-8 my-1 bg-blue-700 border-blue-700 min-w-28 p-button-sm"
            onClick={handleAddShiftCategory}
          ></PrwcBasicButton>
        </div>
      </div>

      <PrwcSidebar
        headerTitle={
          operationType === OperationType.ADD
            ? t("shiftCategory.label.addShiftCategory")
            : t("shiftCategory.label.editShiftCategory")
        }
        isSideBarVisible={isSideBarVisible}
        enableFullScreen={true}
        position="right"
        className="p-sidebar-md"
        onHide={() => setIsSideBarVisible(false)}
      >
        <ShiftCategoryContainer data={selectedRowData}></ShiftCategoryContainer>
      </PrwcSidebar>

      <div className="mt-4">
        <ShiftCategoryListContainer onEdit={handleEditShiftCategory}></ShiftCategoryListContainer>
      </div>
    </div>
  );
};

export default ShiftCategoryPage;
